var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114 128",
    height: "15.75px",
    width: "21px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.51 57.75c.94 1.88 1.49 4 1.49 6.25 0 7.72-6.28 14-14 14s-14-6.28-14-14 6.28-14 14-14V40c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24c0-3.86-.94-7.49-2.56-10.72l-8.93 4.47M57 96c-25.89 0-46-25.52-46-32 0-6.47 20.11-32 46-32s46 25.53 46 32c0 6.48-20.11 32-46 32zm0-74C26.92 22 1 50.17 1 64s25.92 42 56 42 56-28.17 56-42-25.92-42-56-42",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/show-icon.797ad4695d9f07ff82bc6b7928536623.svg";
export { ForwardRef as ReactComponent };